<div class="content-container bg-white">
    <h1>{{
            (editingMyProfile
                ? 'EditionDeMonProfil'
                : (isEditMode ? 'editionDUnBackoffice' : 'creationDUnBackoffice')) | translate
        }}</h1>

    @if (isEditMode && !editingMyProfile) {
        <div>
            <p><em translate="messages.avertissementReattributionCompteBackoffice"></em></p>
        </div>
    }

    <div class="btn-bar">
        <button class="btn btn-outline-secondary" type="button"
                (click)="back()"
                translate="common.back">
        </button>
        @if (isEditMode && !editingMyProfile) {
            <button class="btn btn-outline-danger" type="button"
                    (click)="deleteBackoffice()"
                    translate="common.delete">
            </button>
        }
    </div>

    <form [formGroup]="backofficeForm" class="mt-4">

        <!-- Title -->
        <div class="row">
            <div class="col-12">
                <label class="form-label">{{ 'users.form.title.label' | translate }}*</label>

                <div class="form-check">
                    <input class="form-check-input" type="radio" id="Madam" name="title"
                           value="Madam"
                           [formControl]="title">
                    <label class="form-check-label" for="Madam"
                           translate="users.form.title.madam"></label>
                </div>
                <div class="form-check">
                    <input class="form-check-input" type="radio" id="Mister" name="title"
                           value="Mister"
                           [formControl]="title">
                    <label class="form-check-label" for="Mister"
                           translate="users.form.title.mister"></label>
                </div>
                <div class="form-check">
                    <input class="form-check-input" type="radio" id="notSpecified" name="title"
                           value="NotSpecified"
                           [formControl]="title">
                    <label class="form-check-label" for="notSpecified"
                           translate="users.form.title.notspecified"></label>
                </div>
                <app-form-error [control]="title"></app-form-error>
            </div>

            <!-- AccountEnabled -->
            @if (!editingMyProfile) {
                <div class="col-12 col-lg-6">
                    <label class="form-label">{{ 'users.form.accountEnabled.label' | translate }}*</label>
                    <div class="form-check form-switch">
                        <input class="form-check-input" id="accountEnabled" type="checkbox" name="accountEnabled"
                               [formControl]="accountEnabled">
                        <label class="form-check-label" for="accountEnabled">
                            {{ (accountEnabled.value ? 'users.form.accountEnabled.true' : 'users.form.accountEnabled.false') | translate }}
                        </label>
                    </div>
                    <app-form-error [control]="accountEnabled"></app-form-error>
                </div>
            }

            <!-- firstname -->
            <div class="col-12 col-lg-6">
                <label class="form-label" for="firstname">{{ 'users.form.firstname' | translate }}*</label>
                <input class="form-control" id="firstname" type="text" maxlength="50"
                       placeholder="{{ 'users.form.firstname' | translate }}"
                       [formControl]="firstname"
                       pattern="{{textInputPattern}}">
                <app-form-error [control]="firstname"></app-form-error>
            </div>

            <!-- lastname -->
            <div class="col-12 col-lg-6">
                <label class="form-label" for="lastname">{{ 'users.form.lastname' | translate }}*</label>
                <input class="form-control" id="lastname" type="text" maxlength="50"
                       placeholder="{{ 'users.form.lastname' | translate }}"
                       [formControl]="lastname"
                       pattern="{{textInputPattern}}">
                <app-form-error [control]="lastname"></app-form-error>
            </div>

            <!-- birthDate -->
            <div class="col-12 col-lg-6">
                <label class="form-label" for="birthDate" translate="users.form.birthDate"></label>
                <div class="input-group">
                    <input class="form-control" placeholder="{{ 'common.placeholders.dateFormat' | translate }}"
                           id="birthDate"
                           [formControl]="birthDate"
                           ngbDatepicker
                           #dpBirthDate="ngbDatepicker">
                    <div class="input-group-append">
                        <button class="btn btn-link btn-sm" (click)="dpBirthDate.toggle()">
                            <fa-icon [icon]="icons.calendar"></fa-icon>
                        </button>
                        @if (!!birthDate.value) {
                            <button class="btn btn-link btn-sm" (click)="birthDate.setValue(null)">
                                <fa-icon [icon]="icons.times"></fa-icon>
                            </button>
                        }
                    </div>
                </div>
                <app-form-error [control]="birthDate"></app-form-error>
            </div>

            <!-- email -->
            <div class="col-12 col-lg-6">
                <label class="form-label" for="email">{{ 'users.form.email' | translate }}*</label>
                <input class="form-control" id="email" type="text" maxlength="75"
                       placeholder="{{ 'users.form.email' | translate }}"
                       [formControl]="email"
                       pattern="{{textInputPattern}}">
                <app-form-error [control]="email"></app-form-error>
            </div>

            <!-- street -->
            <div class="col-12 col-lg-6">
                <label class="form-label" for="street">{{ 'users.form.street' | translate }}*</label>
                <input class="form-control" id="street" type="text" maxlength="50"
                       placeholder="{{ 'users.form.street' | translate }}"
                       [formControl]="street"
                       pattern="{{textInputPattern}}">
                <app-form-error [control]="street"></app-form-error>
            </div>

            <!-- postalCode -->
            <div class="col-12 col-lg-6">
                <label class="form-label" for="postalCode">{{ 'users.form.postalCode' | translate }}*</label>
                <input class="form-control" id="postalCode" type="text" maxlength="10"
                       placeholder="{{ 'users.form.postalCode' | translate }}"
                       [formControl]="postalCode"
                       pattern="{{textInputPattern}}">
                <app-form-error [control]="postalCode"></app-form-error>
            </div>

            <!-- city -->
            <div class="col-12 col-lg-6">
                <label class="form-label" for="city">{{ 'users.form.city' | translate }}*</label>
                <input class="form-control" id="city" type="text" maxlength="25"
                       placeholder="{{ 'users.form.city' | translate }}"
                       [formControl]="city"
                       pattern="{{textInputPattern}}">
                <app-form-error [control]="city"></app-form-error>
            </div>

            <!-- country -->
            <div class="col-12 col-lg-6">
                <label class="form-label" for="country">{{ 'users.form.country' | translate }}*</label>
                <input class="form-control" id="country" type="text" maxlength="25"
                       placeholder="{{ 'users.form.country' | translate }}"
                       [formControl]="country"
                       pattern="{{textInputPattern}}">
                <app-form-error [control]="country"></app-form-error>
            </div>

            <!-- phonePrivate -->
            <div class="col-12 col-lg-6">
                <label class="form-label" for="phone" translate="users.form.phone"></label>
                <input class="form-control" id="phone" type="tel" maxlength="25"
                       placeholder="{{ 'common.placeholders.phone' | translate }}"
                       [formControl]="phone">
            </div>

            <!-- phoneMobile -->
            <div class="col-12 col-lg-6">
                <label class="form-label" for="mobilePhone" translate="users.form.mobilePhone"></label>
                <input class="form-control" id="mobilePhone" type="tel" maxlength="25"
                       placeholder="{{ 'common.placeholders.phone' | translate }}"
                       [formControl]="mobilePhone">
            </div>

            <!-- phoneProfessional -->
            <div class="col-12 col-lg-6">
                <label class="form-label" for="businessPhone" translate="users.form.businessPhone"></label>
                <input class="form-control" id="businessPhone" type="tel" maxlength="25"
                       placeholder="{{ 'common.placeholders.phone' | translate }}"
                       [formControl]="businessPhone">
            </div>

            <!-- comment -->
            @if (!editingMyProfile) {
                <div class="col-12">
                    <label class="form-label" for="comment" translate="users.form.comment"></label>
                    <textarea class="form-control" id="comment" maxlength="255"
                              [formControl]="comment"></textarea>
                    <app-form-error [control]="comment"></app-form-error>
                </div>
            }
        </div>

        <!-- Permissions -->
        @if (!editingMyProfile) {
            <app-permission-management formControlName="permissions"></app-permission-management>
        }

        <!-- Modification history -->
        @if (isEditMode && backofficeId && !editingMyProfile) {
            <div ngbAccordion [appHasAnyPermission]="[PermissionKeys.gestionBackoffices]"
                 class="mt-4"
                 (show)="fetchAudits()">
                <div ngbAccordionItem>
                    <h2 ngbAccordionHeader>
                        <button ngbAccordionButton translate="users.history.title"></button>
                    </h2>

                    <div ngbAccordionCollapse>
                        <div ngbAccordionBody>
                            <ng-template>
                                @if (!!pagedAudits) {
                                    <ngx-datatable
                                        class="material"
                                        [columnMode]="'force'"
                                        [rows]="pagedAudits.results"
                                        [headerHeight]="50"
                                        [footerHeight]="50"
                                        [rowHeight]="'auto'"
                                        [externalPaging]="true"
                                        [externalSorting]="true"
                                        [count]="pagedAudits.rowCount"
                                        [messages]="{
                                            totalMessage: 'common.datatable.total' | translate
                                        }"
                                        [offset]="auditCurrentPage"
                                        [limit]="auditPageSize"
                                        (page)="setAuditsPage($event)"
                                        [scrollbarH]="true"
                                        [rowClass]="getRowClass">

                                        <!-- Date -->
                                        <ngx-datatable-column [width]="150" [sortable]="false" name="{{ 'common.date.date' | translate }}">
                                            <ng-template ngx-datatable-cell-template let-audit="row">
                                                {{ audit.modificationDate | date:dateTimeFormat }}
                                            </ng-template>
                                        </ngx-datatable-column>

                                        <!-- Modification user -->
                                        <ngx-datatable-column [width]="300" [sortable]="false"
                                                              name="{{ 'users.history.author' | translate }}">
                                            <ng-template ngx-datatable-cell-template let-audit="row">
                                                {{ audit.modificationUser }}
                                            </ng-template>
                                        </ngx-datatable-column>

                                        <!-- Modifications -->
                                        <ngx-datatable-column [width]="600" [sortable]="false"
                                                              name="{{ 'users.history.modifications' | translate }}">
                                            <ng-template ngx-datatable-cell-template let-audit="row">
                                                <!-- Basic entity properties change -->
                                                @if (audit.changeType === BackofficeAuditEntryPropertyChangeType.PropertyChange) {
                                                    <div>
                                                        @for (change of audit.properties; track change) {
                                                            <div>
                                                                @if (change.propertyName === 'Title') {
                                                                    <strong>{{ 'users.history.fields.' + change.propertyName | translate }}</strong>
                                                                    :
                                                                    {{ 'users.form.title.' + change.oldValue.toLowerCase() | translate }}
                                                                    ->
                                                                    {{ 'users.form.title.' + change.newValue.toLowerCase() | translate }}
                                                                } @else {
                                                                    @if (change.propertyName === 'AccountEnabled') {
                                                                        @if (change.newValue === 'True') {
                                                                            <div>
                                                                                {{ 'users.history.accountActivation' | translate }}
                                                                            </div>
                                                                        } @else {
                                                                            <div>
                                                                                {{ 'users.history.accountDeactivation' | translate }}
                                                                            </div>
                                                                        }
                                                                    } @else {
                                                                        <strong>{{ 'users.history.fields.' + change.propertyName | translate }}</strong>
                                                                        :
                                                                        {{ change.oldValue }}
                                                                        ->
                                                                        {{ change.newValue }}
                                                                    }
                                                                }
                                                            </div>
                                                        }
                                                    </div>
                                                }

                                                @switch (audit.changeType) {
                                                    @case (BackofficeAuditEntryPropertyChangeType.BackofficeCreation) {
                                                        <div>
                                                            {{ 'creationDuBackoffice' | translate }}
                                                        </div>
                                                    }
                                                    @case (BackofficeAuditEntryPropertyChangeType.PermissionAssignment) {
                                                        <div>
                                                            {{ 'attributionDeLaPermission' | translate }}
                                                            <i>{{ audit['permissionLabel' + crtLang.toUpperCase()] }}</i>
                                                        </div>
                                                    }
                                                    @case (BackofficeAuditEntryPropertyChangeType.PermissionUnassignment) {
                                                        <div>
                                                            {{ 'desattributionDeLaPermission' | translate }}
                                                            <i>{{ audit['permissionLabel' + crtLang.toUpperCase()] }}</i>
                                                        </div>
                                                    }
                                                }
                                            </ng-template>
                                        </ngx-datatable-column>
                                    </ngx-datatable>
                                }
                            </ng-template>
                        </div>
                    </div>
                </div>
            </div>
        }

        <!-- Save button -->
        <div class="btn-bar mt-4">
            <button class="btn btn-outline-secondary" type="button"
                    (click)="back()"
                    translate="common.back">
            </button>
            @if (editingMyProfile) {
                <button class="btn btn-outline-secondary" type="button"
                        (click)="resetPassword()" translate="users.form.actions.changePassword">
                </button>
            }
            <button class="btn btn-primary" type="button"
                    (click)="save()"
                    [disabled]="backofficeForm.invalid"
                    translate="common.save">
            </button>
        </div>

    </form>
</div>
